import { render, staticRenderFns } from "./SidebarV2.vue?vue&type=template&id=4abca456&scoped=true"
import script from "./SidebarV2.vue?vue&type=script&lang=js"
export * from "./SidebarV2.vue?vue&type=script&lang=js"
import style0 from "./SidebarV2.vue?vue&type=style&index=0&id=4abca456&prod&lang=scss&scoped=true"
import style1 from "./SidebarV2.vue?vue&type=style&index=1&id=4abca456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abca456",
  null
  
)

export default component.exports